/*
 * @Author: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @Date: 2023-12-06 08:30:56
 * @LastEditors: huxg 9506976+huxgs521@user.noreply.gitee.com
 * @LastEditTime: 2024-05-29 11:33:32
 * @FilePath: /front-vps-admin/src/web-framework/api/menu.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import store from '@/public/store';
import router from '@/public/router';
import UserAPI from '@/web-framework/api/user.js';
const MenuAPI = {
    /**
     * @description: 查找菜单模板
     * @param {*} query
     * @return {*}
     */
    searchMenuTemplate(query) {
        return Request.post('/admin/identity/search', query || {});
    },
    /**
     * @description: 保存菜单模板
     * @param {*} app
     * @return {*}
     */    
    saveMenuTemplate(app) {
        return Request.post('/admin/identity/save', app);
    },
    /**
     * @description: 根据ID删除一个菜单模板
     * @param {*} id
     * @return {*}
     */    
    removeMenuTemplate(id) {
        return Request.delete(`/admin/identity/delete/${id}`);
    },
    /**
     * @description: 批量删除菜单模板
     * @param {*} idArray
     * @return {*}
     */    
    batchRemoveMenuTemplate(idArray) {
        return Request.post('/admin/identity/batchDelete', idArray);
    },
    /**
     * 返回一个身份所具有的菜单
     * @param {} roleId 
     * @returns 
     */
    getMenus(roleId) {
        return Request.get("/admin/menufaced/mymenus", { roleId: roleId });
    },
    /**
     * 返回菜单树
     * @returns 
     */
    menuTree(menuTemplateId, appId) {
        return Request.get("/admin/menu/tree", { menuTemplateId: menuTemplateId, selectedAppId: appId });
    },

    /**
     * 更新菜单数据
     * @param {} menu 
     * @returns 
     */
    updateMenu(menu) {
        return Request.post("/admin/menu/save", menu);
    },

    /**
     * 通过Id获取菜单
     * @param {} menuId 
     * @returns 
     */
    getMenu(menuId) {
        return Request.get(`/admin/menu/${menuId}`);
    },
    /**
     * 删除一个菜单
     * @param {*} menuId 
     * @returns 
     */
    removeMenu(menuId) {
        return Request.delete(`/admin/menu/delete/${menuId}`);
    },

    /**
     * 批量更新带单顺序
     * @param {} menuOrderArray 
     * @returns 
     */
    updateMenuSorts(menuOrderArray) {
        return Request.post("/admin/menu/updateMenuSorts", menuOrderArray);
    },

    /**
     * 批量更新菜单
     * @param {*} menus 
     * @returns 
     */
    batchUpdate(menus) {
        return Request.post("/admin/menu/batchUpdate", menus);
    },
    /**
     * 根据角色id获取该角色所有菜案
     */
    findMenusByRole(roleId) {
        return Request.get('/admin/menu/findMenusByRole', { roleId: roleId })
    },
    /**
     * 获取根路由
     */
    getRootPath(vm) {
        let path = vm.$route.path;
        path = path.substring(1, path.length);
        let index = path.indexOf('/');
        if (index == -1) {
            return vm.$route.path;
        } else {
            return '/' + path.substring(0, index);
        }
    },
    /**
     * 查找菜单权限
     * @param {*} query 
     * @returns 
     */
    findMenuPermissions(query) {
        return Request.post('/admin/menuPermission/search', query);
    },
    /**
     * 删除菜单权限
     * @param {*} id 
     * @returns 
     */
    removeMenuPermission(id) {
        return Request.delete(`/admin/menuPermission/delete/${id}`);
    },
    /**
     * 批量删除
     * @param {*} idArray 
     * @returns 
     */
    batchRemoveMenuPermissions(idArray) {
        return Request.post('/admin/menuPermission/batchDelete', idArray);
    },
    /**
     * 在menu中查找与当前路由匹配的菜单
     */
    findMenuByRoute(menus, routePath) {
        let pathToRegexp = require('path-to-regexp');
        let findMenu = function(array) {
            for (let i = 0; i < array.length; i++) {
                let fullPath = array[i].fullPath;

                if (pathToRegexp(fullPath).test(routePath)) {
                    return array[i];
                }

                if (array[i].children && array[i].children.length > 0) {
                    let founded = findMenu(array[i].children, routePath);
                    if (founded) {
                        return founded;
                    }
                }
            }
        };
        let founded = findMenu(menus, routePath);
        return founded;
    },
    findMenuWithPath(vm, menus, path) {
        let p = vm.Utils.filterArray(menus, "path", path);
        return p[0];
    },

    /**
     * 查找子菜单
     * @param {} menu 
     * @returns 
     */
    findFirstMenuInChildren(menu) {
        let level = 0;
        let findMenu = function(array) {
            for (let i = 0; i < array.length; i++) {
                if (array[i] == menu) {
                    level = 0;
                }

                if (level == 1 && array[i].fullPath && array[i].fullPath.length > 0) {
                    return array[i];
                } else {
                    if (array[i].children && array[i].children.length > 0) {
                        level++;
                        let founded = findMenu(array[i].children);
                        if (founded) {
                            return founded;
                        }
                    } else if (array[i].fullPath && array[i].fullPath.length > 0) {
                        return array[i];
                    }
                }
            }
        };
        let founded = findMenu(menu.children);
        return founded;
    },

    initFrameworkMenus(menus) {
        let loopRouteFun = function(parentRoute, thisRoute) {
            let route = {
                id: thisRoute.id,
                name: thisRoute.path,
                title: thisRoute.name,
                redirect: (!thisRoute.redirectUrl || thisRoute.redirectUrl.length == 0 || thisRoute.redirectUrl.startsWith('/')) ? thisRoute.redirectUrl : undefined,
                path: thisRoute.path,
                icon: thisRoute.icon,
                page: thisRoute.page,
                uniqueId: thisRoute.path,
                meta: thisRoute.meta && thisRoute.meta.length > 0 ? JSON.parse(thisRoute.meta) : {},
                component: () => (thisRoute.page && thisRoute.page.length > 0) ? import(`@/web-framework/pages${thisRoute.page.trim()}`) : import(`@/web-framework/pages/pub/empty.vue`)
            };

            if (!parentRoute.children) {
                parentRoute.children = [];
            }
            parentRoute.children.push(route);
            if (thisRoute.children) {
                for (let i = 0; i < thisRoute.children.length; i++) {
                    loopRouteFun(route, thisRoute.children[i]);
                }
            }
        };

        let publicMenus = [];
        for (let i = 0; i < menus.length; i++) {
            let route = {
                id: menus[i].path,
                name: menus[i].path,
                title: menus[i].name,
                redirect: (!menus[i].redirectUrl || menus[i].redirectUrl.length == 0 || menus[i].redirectUrl.startsWith('/')) ? menus[i].redirectUrl : undefined,
                path: menus[i].path,
                icon: menus[i].icon,
                page: menus[i].page,
                uniqueId: menus[i].path,
                meta: menus[i].meta && menus[i].meta.length > 0 ? JSON.parse(menus[i].meta) : {},
                component: () => (menus[i].page && menus[i].page.length > 0) ? import(`@/web-framework/pages${menus[i].page.trim()}`) : import(`@/web-framework/pages/pub/empty.vue`)
            };
            if (menus[i].children) {
                for (let j = 0; j < menus[i].children.length; j++) {
                    loopRouteFun(route, menus[i].children[j]);
                }
            }
            publicMenus.push(route);
        }
        return publicMenus;
    },

    /**
     * 获取路由
     * @returns 
     */
    async initMenus() {
        let loopRouteFun = function(parentRoute, thisRoute) {
            let route = {
                id: thisRoute.id,
                name: thisRoute.uniqueId,
                title: thisRoute.name,
                redirect: (!thisRoute.redirectUrl || thisRoute.redirectUrl.length == 0 || thisRoute.redirectUrl.startsWith('/')) ? thisRoute.redirectUrl : (thisRoute.fullPath + '/' + thisRoute.redirectUrl),
                path: thisRoute.url,
                icon: thisRoute.icon,
                order: thisRoute.sortNum,
                fullPath: thisRoute.fullPath,
                page: thisRoute.page,
                showOnLeftTreeMenu: thisRoute.showOnLeftTreeMenu,
                replaceParentMenu: thisRoute.replaceParentMenu,
                uniqueId: thisRoute.uniqueId,
                meta: thisRoute.meta && thisRoute.meta.length > 0 ? JSON.parse(thisRoute.meta) : {},
                component: () => (thisRoute.page && thisRoute.page.length > 0) ? import(`@/pages${thisRoute.page.trim()}`) : import(`@/web-framework/pages/pub/empty.vue`)
            };

            if (!parentRoute.children) {
                parentRoute.children = [];
            }
            parentRoute.children.push(route);
            if (thisRoute.subMenus) {
                for (let i = 0; i < thisRoute.subMenus.length; i++) {
                    loopRouteFun(route, thisRoute.subMenus[i]);
                }
            }
        };


        let userRole = UserAPI.getUserRole();
        let menuResult = await this.getMenus(userRole.id);
        if (menuResult.success == false) {
            throw new exception(menuResult);
        }

        if (menuResult.success && menuResult.data && menuResult.data.length > 0) {
            let menus = menuResult.data;
            let asyncRoutes = [];
            for (let i = 0; i < menus.length; i++) {
                let route = {
                    id: menus[i].id,
                    name: menus[i].uniqueId,
                    title: menus[i].name,
                    redirect: (!menus[i].redirectUrl || menus[i].redirectUrl.length == 0 || menus[i].redirectUrl.startsWith('/')) ? menus[i].redirectUrl : (menus[i].fullPath + '/' + menus[i].redirectUrl),
                    path: menus[i].url,
                    icon: menus[i].icon,
                    order: menus[i].sortNum,
                    fullPath: menus[i].fullPath,
                    page: menus[i].page,
                    showOnLeftTreeMenu: menus[i].showOnLeftTreeMenu,
                    replaceParentMenu: menus[i].replaceParentMenu,
                    uniqueId: menus[i].uniqueId,
                    meta: menus[i].meta && menus[i].meta.length > 0 ? JSON.parse(menus[i].meta) : {},
                    component: () => (menus[i].page && menus[i].page.length > 0) ? import(`@/pages${menus[i].page.trim()}`) : import(`@/web-framework/pages/pub/empty`)
                };
                if (menus[i].subMenus) {
                    for (let j = 0; j < menus[i].subMenus.length; j++) {
                        loopRouteFun(route, menus[i].subMenus[j]);
                    }
                }
                asyncRoutes.push(route);
            }

            store.dispatch('router/cacheRoutes', asyncRoutes);
            router.addRoutes(asyncRoutes);
        }
    },

};
export default MenuAPI;